
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/nft/referrals",
      function () {
        return require("private-next-pages/nft/referrals.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/nft/referrals"])
      });
    }
  